export default __webpack_public_path__ + "static/media/61.af1a42a4.png";